// TODO add sentry
export default function ({ $sentry, app, redirect }, inject) {
  const logger = {
    captureException: ({ error = {}, checkRedirect = {} }) => {
      if (checkRedirect.hasOwnProperty('name')) {
        const response = error.response
        if (!response) { return }
        const { data } = response
        if (!data) { return }
        const { message } = data
        const notify = {
          message,
          type: 'error'
        }
        app.$auth.$storage.setUniversal('notify', JSON.stringify(notify))
        redirect(
          app.localePath({
            ...checkRedirect
          })
        )
        return
      }
      if (error) {
        if (error.response && error.response.status) {
          const code = parseInt(error.response.status)
          if (code && [400, 401, 302, 301, 422, 429, 500, 503, 504, 410].includes(code)) {
            return
          }
        }

        if ($sentry) {
          $sentry.captureException(error)
        }
      } else {
        console.info('cant call captureException')
        if (process.env.NODE_ENV === 'development') { console.trace(error) }
      }
    }
  }
  inject('logger', logger)
}
